var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_has.js
// module id = 63
// module chunks = 92